export const STRING_REGEX: RegExp = /[\x00-\x1f\x7f]+/;  
